import React, { useLayoutEffect, useContext, useEffect } from 'react';
import { useState } from 'react';
import { MazeResultContext } from '../customCursor/context/MazeResult';
import axios from 'axios';
import gsap from 'gsap';
import Draggable from 'gsap/Draggable';
import Input from '../styledComponents/Input';
import './Maze1.css';
gsap.registerPlugin(Draggable);

const url = process.env.REACT_APP_URL_LOCAL;
const Maze1 = () => {
	const {setMazeOneResult, finalResult} = useContext(MazeResultContext);
	// const mazeCoverRef = useRef(null);
	const [inputValue, setInputValue] = useState('');
	const [resetInput, setResetInput] = useState(false);
	const handlerFunction = async (e) => {
		e.preventDefault();
		if (inputValue.length > 0) {
			try {
				const body = { inputValue };
				const response = await axios.post(`${url}/maze-one`, body);
				if (response.data.success) {
					if (process.env.REACT_APP_MAZE_ONE === response.data.answer) {
						setMazeOneResult(process.env.REACT_APP_MAZE_ONE);
					}
				} else {
					setResetInput(true);
					setMazeOneResult('');

				}
			} catch (error) {
				console.log(error);
			}
		}
	};

	useEffect(() => {
	
	}, [finalResult]);
	// dragable cover
	useLayoutEffect(() => {
		const ctx = gsap.context(() => {
			// const cover = mazeCoverRef.current;
			// console.log(cover);
			Draggable.create(".input-maze-1-cover", {
				type: 'x',
				bounds: { maxX: 250, minX: 0 },
				inertia: true,
				dragResistance: 0.5,
				onClick: function () {
				},
				onDragEnd: function () {
					
				},
			});
		});
		return () => {
			ctx.revert();
		};
	}, []);
	return (
		<section className="maze1-container">
			<p className="description-maze1-title">Enigmas and labyrinths captivate me. Three cryptic conundrums will unveil a project close to my heart, an endeavor to which I dedicate much of my time. Behold, the first one... </p>
			<p className="description-maze1">"Ancient Rome, a bastion of acumen, where legions and senators treaded the forum. Julius, a sovereign adept in cryptic arcana, wove enigmatic laurels. As we unfurl the scrolls of yore, the gears of their age-old wisdom whisper through the bytes and bits of our era."</p>
			<p className="description-maze1">"cqn jwbfna rb jwbfna"</p>
			<form onSubmit={handlerFunction}>
				<div className="input-maze-1">
					<Input inputValue={setInputValue} resetInput={resetInput} setResetInput={setResetInput} />
					<div
						className="input-maze-1-cover"
					></div>
				</div>
			</form>
		</section>
	);
};

export default Maze1;
